import React from 'react';
import { Box, Flex } from 'roo-ui/components';
import PulsingLoadingBlock from 'components/PulsingLoadingBlock';

const blockHeight = 42;

const LoaderSkeleton = () => (
  <Box opacity="0.1">
    <Flex flexDirection={['column', 'row', 'row']} mb={[0, 6]}>
      <PulsingLoadingBlock mr={[0, 4]} mb={[6, 0]} height={blockHeight} width={['100%', '40%']} />
      <PulsingLoadingBlock mb={[6, 0]} height={blockHeight} width={['100%', '60%']} />
    </Flex>
    <Flex flexDirection={['column', 'row', 'row']} mb={[0, 6]}>
      <PulsingLoadingBlock mr={[0, 4]} mb={[6, 0]} height={blockHeight} width={['100%', '40%']} />
      <PulsingLoadingBlock mr={[0, 4]} mb={[6, 0]} height={blockHeight} width={['100%', '40%']} />
      <PulsingLoadingBlock height={blockHeight} width={['100%', '20%']} />
    </Flex>
  </Box>
);

export default LoaderSkeleton;
